module.exports = __webpack_public_path__ + "static/img/case2.c5c9bee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case2.jpg
// module id = sAv8
// module chunks = 1